import { ITEMS_PER_PAGE } from "~/common/constants/items-per-page";

export const getPaginationResponseDefault = () => ({
	page: 1,
	limit: ITEMS_PER_PAGE,
	total: 0
});
